export const createNewField = "Create a new field"
export const updateField = "Update a field"

export const createNewCropping = "Create a new cropping"
export const updateCropping = "Update a cropping"

export const commands = {

    editField: "Edit field",
    editFields: "Edit fields",
    newField: "New field",
    drawFieldBoundary: "Draw the field boundary",
    editFieldBoundary: "Edit the field boundary",

    editCropping: "Edit cropping",
    newCropping: "New cropping",
    drawCropBoundary: "Draw the crop boundary",
    editCropBoundary: "Edit the crop boundary",

    split: "Split",
    merge: "Merge",

    infieldFeatures: "Infield features",

    grassMargin: "Grass margin",

} as const
